import request from '@/utils/request'

import productDetailData from '@/mock/homeProduct.json'

export function list(page, limit) {
	return request({
		url: `/web/products/list?page=${page}&limit=${limit}`,
		method: 'get',
	})
}

export function detail(id) {
	return request({
		url: `/web/products/${id}`,
		method: 'get',
	})
}

export async function work() {
	return {
		code: 0,
		list: [
			{
				createTime: null,
				description: null,
				id: null,
				image: '202103041120322179.png',
				isDelete: null,
				order: null,
				updateTime: null,
			},
			{
				createTime: null,
				description: null,
				id: null,
				image: '202103101036235398.png',
				isDelete: null,
				order: null,
				updateTime: null,
			},
			{
				createTime: null,
				description: null,
				id: null,
				image: '202103101036004835.png',
				isDelete: null,
				order: null,
				updateTime: null,
			},
			{
				createTime: null,
				description: null,
				id: null,
				image: '202103101035504116.png',
				isDelete: null,
				order: null,
				updateTime: null,
			},
		],
	}
}

export function project(id) {
	return new Promise((resolve, reject) => {
		const data = productDetailData.list.find(item => item.id == id)
		if (data) {
			resolve(data)
		} else {
			reject(new Error(`未找到id为${id}的项目数据`))
		}
	})
}

export async function position() {
	return {
		code: 0,
		list: [
			{
				ageLimit: '1-2年',
				content:
					'岗位职责：\n1、负责Web系统服务端开发，完成公司下达的任务；\n2、完成软件系统代码的实现，编写代码注释和开发文档；\n3、辅助进行系统的功能定义，程序设计；\n4、根据设计文档或需求说明完成代码编写，调试测试和维护\n任职资格：\n1、全日制本科及以上学历，计算机相关专业，1年以上Java开发工作经验；\n2、掌握Java基础知识、以及面向对象的设计方法；\n3、掌握Java开发相关技术，熟悉springboot、springcloud等Java后端开发框架；\n4、掌握web前端开发三件套（html/css/javascript），熟悉vue.js开发者优先；\n5、熟悉tomcat等web服务器；\n6、熟悉mysql、redis等主流关系型、内存数据库；\n7、熟悉git或svn使用；\n8、思维活跃，热衷学习新的技术；\n9、性格开朗，善于沟通，能承受工作压力 ',
				createTime: 1614160456000,
				describe:
					'1、负责Web系统服务端开发，完成公司下达的任务；\n2、完成软件系统代码的实现，编写代码注释和开发文档；',
				id: 2,
				isDelete: 0,
				num: 5,
				order: 1,
				site: '成都',
				status: 0,
				title: 'java初级开发',
				updateTime: 1615189142000,
			},
			{
				ageLimit: '3-5年',
				content:
					'岗位职责：\n1、能够协助完成软件设计，作为开发主程完成主要代码；\n2、能进行代码编编写和评审，并对初级工程师进行技术指导；\n3、对于项目中遇到的技术难题进行攻坚；\n4、根据项目需求，和合作方技术人员进行技术沟通及接口规范的沟通和指定；\n5、配合项目实施需求进行软件接口调试及问题解决\n任职资格：\n1、全日制本科及以上学历，计算机相关专业，3年以上Java开发工作经验，有银行、证券等金融行业开发经验者优先；\n2、掌握Java基础知识、以及面向对象的设计方法，熟悉GOF  23种设计模式中常用的几种；；\n3、掌握Java开发相关技术，熟悉springboot、springcloud等Java后端开发框架能熟练使用IDEA及其各种常用插件；\n4、熟悉Oracle/Mysql等数据库，熟练使用Mybatis开发插件， 掌握SQL语言，能根据需求熟练编写SQL代码；\n5、掌握web前端开发三件套（html/css/javascript），熟悉 vue.js和React.js开发者优先，可根据需要短期内随时支持前端开发者优先；\n6、熟悉tomcat、Nginx等Web服务器的配置，熟悉反向代理、 双机备份、负载均衡、keepalive技术者优先；\n7、熟悉Redis等主流内存数据库的配置和使用，熟悉Linux/ Windows运行和配置环境；\n8、熟悉Git或Svn使用；\n9、思维活跃，热衷学习新的技术；\n10、性格开朗，善于沟通，能承受工作压力 ',
				createTime: 1615258798000,
				describe:
					'1、能够协助完成软件设计，作为开发主程完成主要代码；\n2、能进行代码编编写和评审，并对初级工程师进行技术指导；',
				id: 1,
				isDelete: 0,
				num: 5,
				order: 2,
				site: '成都',
				status: 0,
				title: 'java中级开发',
				updateTime: 1615258798000,
			},
			{
				ageLimit: '3-5年',
				content:
					'岗位要求\n1. 参与产品研发、业务效果数据追踪等，负责WEB前端架构设计; \n2. 通过对业务深刻的理解，改进WEB前端技术方案，提高WEB前端研发团队整体的研发效率和质量； \n3. 辅导、带领新人，传道授业解惑，提升WEB前端开发团队整体技术水平;\n4. 保证Web界面在不同分辨率或移动端上保持优质的用户体验\n\n任职要求\n1. 全日制本科及以上学历，计算机相关专业，3年以上WEB前端开发经验；\n2. 精通各种Web前端技术（HTML/CSS/Javascript等)，熟练跨浏览器、跨终端的开发；\n3. 精通React、AngularJS、Vue等MVVM框架至少一种，并有在大型项目中使用的成功经验；\n4. 熟悉React.js Web应用开发，有大型 React.js项目的开发经验；\n5. 熟悉Web安全相关知识，并能使用相关技术防范安全漏洞； \n6. 有大型网站前端架构、前端性能、可访问性、可维护性等方面的实践经验； \n7. 良好的沟通表达能力，个性乐观开朗，逻辑性强，善于和各种背景的人合作； \n8. 至少熟悉一种后端开发语言，有后端开发经验者优先； \n9. 对智慧物流行业产品有浓厚兴趣，有中后台产品开发经验； \n10. 好的中英文读写能力。',
				createTime: 1614234471000,
				describe:
					'1、参与产品研发、业务效果数据追踪等，负责WEB前端架构设计;\n2、通过对业务深刻的理解，改进WEB前端技术方案，提高WEB前端研发团队整体的研发效率和质量；\n3、精通React、AngularJS、Vue等MVVM框架至少一种，并有在大型项目中使用的成功经验；\n4、熟悉React.js Web应用开发，有大型 React.js项目的开发经验；\n',
				id: 3,
				isDelete: 0,
				num: 1,
				order: 3,
				site: '成都市',
				status: 0,
				title: 'WEB前端工程师',
				updateTime: 1615189070000,
			},
			{
				ageLimit: '1-3年',
				content:
					'岗位职责：\n1、参与测试用例编写与评审；\n2、执行测试用例，并对执行结果负责，跟踪软件缺陷并协助开发人员修改；\n3、编写测试报告，并能够提出软件优化意见；\n4、重现客户发现的问题并进行追踪，协助其他人员进行产品问题的解决。\n任职要求：\n1、全日制大学本科及以上学历，1年以上功能测试经验；\n2、熟悉软件测试理论，测试流程，能根据需求文档编写测试用例，形成测试报告；\n3、有B/S架构系统WEB、app应用程序的测试经验；\n4、能够熟练使用一种测试管理工具（redmine、testlink、禅 道等）；\n5、熟悉sql，能对数据库进行简单操作;\n6、性格开朗，善于沟通，能承受工作压力 ',
				createTime: 1614751853000,
				describe:
					'1、参与测试用例编写与评审；\n2、执行测试用例，并对执行结果负责，跟踪软件缺陷并协助开发人员修改；\n3、编写测试报告，并能够提出软件优化意见；\n4、重现客户发现的问题并进行追踪，协助其他人员进行产品问题的解决。',
				id: 4,
				isDelete: 0,
				num: 1,
				order: 4,
				site: '成都市',
				status: 0,
				title: '测试工程师',
				updateTime: 1615258749000,
			},
		],
	}
}
